(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8231],{

/***/ 30402:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/print.9f8da7b0.svg","height":17,"width":17});

/***/ }),

/***/ 48595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ql": function() { return /* binding */ getLoadMoreAnalyticsData; },
/* harmony export */   "a$": function() { return /* binding */ plpGetBackToTopAnalytics; },
/* harmony export */   "cI": function() { return /* binding */ defaultGetBackToTopAnalytics; },
/* harmony export */   "gr": function() { return /* binding */ technicalSpecGetBackToTopAnalytics; },
/* harmony export */   "tf": function() { return /* binding */ searchGetBackToTopAnalytics; }
/* harmony export */ });
/* unused harmony exports searchLoadMoreAnalyticsData, technicalSpecLoadMoreAnalyticsData, articleLoadMoreAnalyticsData, defaultLoadMoreAnalyticsData */
const searchGetBackToTopAnalytics = (type)=>JSON.stringify({
        eventAction: "search results:".concat(type, ":main content area:back to top"),
        eventName: "search results:".concat(type, ":main content area:back to top"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to top",
        internalLinkPosition: "search results",
        internalLinkType: "search results:navigation",
        internalLinkZoneName: "search results:".concat(type, ":main content area"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
const technicalSpecGetBackToTopAnalytics = JSON.stringify({
    eventAction: "technical specs:main content area:back to top",
    eventName: "technical specs:main content area:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "tech specs",
    internalLinkType: "technical specs:navigation",
    internalLinkZoneName: "technical specs:main content area",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const plpGetBackToTopAnalytics = JSON.stringify({
    eventAction: "plp:back to top",
    eventName: "plp:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "plp",
    internalLinkType: "plp:navigation",
    internalLinkZoneName: "plp:promo tiles",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const defaultGetBackToTopAnalytics = JSON.stringify({
    eventAction: "support:help and faq:article list:back to top",
    eventName: "support:help and faq:article list:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "support:help and faq",
    internalLinkType: "support:help and faq:navigation",
    internalLinkZoneName: "support:help and faq:article list",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const searchLoadMoreAnalyticsData = (tab)=>JSON.stringify({
        eventAction: "search results:".concat(tab, ":main content area:load more"),
        eventName: "search results:".concat(tab, ":main content area:load more"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "load more",
        internalLinkPosition: "search results",
        internalLinkType: "search results:load more",
        internalLinkZoneName: "search results:".concat(tab, ":main content area"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
const technicalSpecLoadMoreAnalyticsData = '{"eventAction":"technical specs:main content area:load more","eventName":"technical specs:main content area:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"tech specs","internalLinkType":"technical specs:load more","internalLinkZoneName":"technical specs:main content area","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const articleLoadMoreAnalyticsData = '{"eventAction":"support:help and faq:article list:load more","eventName":"support:help and faq:article list:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"support:help and faq","internalLinkType":"support:help and faq:load more","internalLinkZoneName":"support:help and faq:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const defaultLoadMoreAnalyticsData = '{"eventAction":"plp load more","eventName":"plp load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"plp","internalLinkType":"plp:load more","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const getLoadMoreAnalyticsData = function() {
    let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", tab = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "products";
    let analyticsData = "";
    if (page === "search") {
        analyticsData = searchLoadMoreAnalyticsData(tab.toLowerCase());
    } else if (page === "technicalspecs") {
        analyticsData = technicalSpecLoadMoreAnalyticsData;
    } else if (page === "article") {
        analyticsData = articleLoadMoreAnalyticsData;
    } else {
        analyticsData = defaultLoadMoreAnalyticsData;
    }
    return analyticsData;
};


/***/ }),

/***/ 57050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dm": function() { return /* binding */ orderPaginationAnalytics; },
/* harmony export */   "Up": function() { return /* binding */ orderBackToTopAnalytics; },
/* harmony export */   "d$": function() { return /* binding */ loadMoreAnalytics; },
/* harmony export */   "eL": function() { return /* binding */ continueAnalytics; },
/* harmony export */   "md": function() { return /* binding */ orderDetailsAnalytics; }
/* harmony export */ });
/* unused harmony export orderSignOutAnalytics */
const { pushAnalyticsObjToDataLayer , getAnalyticLinkUrl  } = __webpack_require__(34326);
const orderDetailsAnalytics = function() {
    let orderType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "open", url = arguments.length > 1 ? arguments[1] : void 0;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:".concat(orderType, " orders:order details"),
        eventName: "my account:orders:".concat(orderType, " orders:order details"),
        eventType: "navigation",
        internalLinkName: "order details",
        internalLinkPosition: "my account",
        internalLinkType: "my account:submitted",
        internalLinkZoneName: "my account:orders:".concat(orderType, " orders"),
        internalLinkURL: getAnalyticLinkUrl(url)
    };
    return JSON.stringify(eventInfo);
};
const continueAnalytics = (url)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:continue shopping",
        eventName: "my account:orders:continue shopping",
        eventType: "navigation",
        internalLinkName: "continue shopping",
        internalLinkPosition: "my order",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders:open orders",
        internalLinkURL: url ? url.indexOf("http") === -1 ? window.location.origin : "" : "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const orderSignOutAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:sign out",
        eventName: "my account:orders:sign out",
        eventType: "navigation",
        internalLinkName: "sign out",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders",
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const loadMoreAnalytics = function() {
    let orderType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "open";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:".concat(orderType, " orders:load more"),
        eventName: "my account:orders:".concat(orderType, " orders:load more"),
        eventType: "navigation",
        internalLinkName: "load more",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders:".concat(orderType, " orders"),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const orderBackToTopAnalytics = function() {
    let orderType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "open";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:".concat(orderType, " orders:back to top"),
        eventName: "my account:orders:".concat(orderType, " orders:back to top"),
        eventType: "navigation",
        internalLinkName: "back to top",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:orders:".concat(orderType, " orders"),
        internalLinkURL: "n/a"
    };
    return JSON.stringify(eventInfo);
};
const orderPaginationAnalytics = function() {
    let orderType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "open", count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:orders:".concat(orderType, " orders:pagination"),
        eventName: "my account:orders:".concat(orderType, " orders:pagination"),
        eventType: "navigation",
        internalLinkName: count,
        internalLinkPosition: "my account",
        internalLinkType: "my account:pagination bottom",
        internalLinkZoneName: "my account:orders:".concat(orderType, " orders"),
        internalLinkURL: "n/a"
    };
    return JSON.stringify(eventInfo);
};


/***/ }),

/***/ 28231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cart_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
;// CONCATENATED MODULE: ./components/cart/Pagination/LoadMore.jsx




const LoadMore = (param)=>{
    let { totalResults =0 , staticTexts ={} , onLoadMore =()=>{} , curRows =30 , data =[] , removeLoadAnimation =false  } = param;
    const transformClassName = removeLoadAnimation ? "no-transform" : "";
    const handleLoadMore = ()=>{
        onLoadMore();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "gbh-data-layer",
        children: totalResults > constants.DEFAULT_PRODUCT_COUNT_PLP && totalResults > curRows && totalResults > (data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            type: "load-more",
            size: "small",
            customClass: "abandonedCarts__load-more ".concat(transformClassName),
            label: staticTexts.loadMore,
            parentClass: "div-wrapper",
            onClick: handleLoadMore,
            role: "button"
        })
    });
};
/* harmony default export */ var Pagination_LoadMore = (LoadMore);

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./public/icons/back-top-arrow.svg
var back_top_arrow = __webpack_require__(12522);
// EXTERNAL MODULE: ./public/icons/print.svg
var print = __webpack_require__(30402);
// EXTERNAL MODULE: ./public/icons/share.svg
var share = __webpack_require__(66773);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/ProductsPerPage/index.module.scss
var index_module = __webpack_require__(15803);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/Shared/OrderHistory/v1/analytics.js
var analytics = __webpack_require__(57050);
;// CONCATENATED MODULE: ./components/cart/Pagination/ProductsPerPage.jsx




const ProductsPerPage = (param)=>{
    let { data =[] , texts , page , onChange , totalResults , curRows =30 , pos ="top" , selectedTab  } = param;
    const getAnalyticsData = function() {
        let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        limit = limit + "";
        let analyticsData = "";
        if (page === "search") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: limit,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: texts.all,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "technicalspecs") {
            if (!all) {
                analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "favorites") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(limit),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(texts.all),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "article") {
            analyticsData = JSON.stringify({
                eventAction: "support:help and faq:article list:pagination",
                eventName: "support:help and faq:article list:pagination",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: !all ? limit : texts.all,
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:pagination " + pos,
                internalLinkZoneName: "support:help and faq:article list",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else if (page === "literature") {
            if (!all) {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-release") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press releases:pagination","eventName":"press room:press releases:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press releases:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press releases:pagination","eventName":"press room:press releases:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press releases:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-kits") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "orderList") {
            analyticsData = (0,analytics/* orderPaginationAnalytics */.Dm)(selectedTab, all ? "all" : limit);
        } else {
            const internalLinkZoneName = pos === "top" ? '"plp:sticky nav filter"' : '"plp:promo tiles"';
            if (!all) {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        }
        return analyticsData;
    };
    const checkPaginationPosition = (limit)=>{
        onChange(limit);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).productPerPageWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "products-per-page",
            children: totalResults > 30 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                role: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "disabled",
                        "aria-hidden": true,
                        children: texts.view
                    }),
                    data.map((limit, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            "aria-disabled": curRows === limit,
                            role: "button",
                            tabIndex: "0",
                            "aria-label": "".concat(texts.view, " ").concat(limit, " ").concat(texts.items),
                            className: (curRows === limit && "disabled") + " gbh-data-layer",
                            "data-gbh-data-layer": getAnalyticsData(limit),
                            onClick: ()=>checkPaginationPosition(limit),
                            children: limit
                        }, i)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        role: "button",
                        tabIndex: "0",
                        "aria-label": "".concat(texts.view, " ").concat(texts.all, " ").concat(texts.items),
                        className: (curRows === totalResults && "disabled") + " gbh-data-layer",
                        "data-gbh-data-layer": getAnalyticsData("", true),
                        onClick: ()=>onChange(totalResults),
                        children: texts.all
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Pagination_ProductsPerPage = (ProductsPerPage);

// EXTERNAL MODULE: ./components/cart/OrderSummary/SocialShare.jsx
var SocialShare = __webpack_require__(22006);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/Pagination/analytics.js
var Pagination_analytics = __webpack_require__(48595);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/cart/Pagination/Pagination.jsx











const Pagination = (param)=>{
    let { displayPrint ="" , staticTexts ={} , displayShare ="" , curRows =30 , productsPerPage =[] , totalResults =0 , onRows =()=>{} , handleBackToTop =()=>{} , width =1280 , isSearchTab =false , page ="" , type ="" , customClass ={} , includeWrapper =true  } = param;
    const { print ="" , share ="" , backToTop =""  } = staticTexts;
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const { buttonClass ="" , spanClass ="" , imgClass =""  } = customClass !== null && customClass !== void 0 ? customClass : {};
    const getBackToTopAnalyticsData = ()=>{
        if (isSearchTab && page === "search") return (0,Pagination_analytics/* searchGetBackToTopAnalytics */.tf)(type);
        else if (page === "technicalspecs") return Pagination_analytics/* technicalSpecGetBackToTopAnalytics */.gr;
        else if (page === "plp") return Pagination_analytics/* plpGetBackToTopAnalytics */.a$;
        else if (page === "orderList") return (0,analytics/* orderBackToTopAnalytics */.Up)(type);
        else return Pagination_analytics/* defaultGetBackToTopAnalytics */.cI;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(utils/* ConditionalWrapper */.M2, {
        condition: includeWrapper,
        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-listing__row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-listing__back-to-top",
                    children: children
                })
            }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_ProductsPerPage, {
                pos: "bottom",
                curRows: curRows,
                data: productsPerPage,
                totalResults: totalResults,
                texts: staticTexts,
                onChange: onRows,
                selectedTab: type,
                page: page
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                role: "link",
                className: "".concat(buttonClass || "product-listing__go-back", " gbh-data-layer"),
                "data-gbh-data-layer": getBackToTopAnalyticsData(),
                onClick: handleBackToTop,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat(spanClass || "product-listing__go-back-text"),
                        children: backToTop
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "".concat(imgClass || "product-listing__go-back-image"),
                        "aria-hidden": "true",
                        src: back_top_arrow/* default */.Z === null || back_top_arrow/* default */.Z === void 0 ? void 0 : back_top_arrow/* default.src */.Z.src,
                        alt: backToTop
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Pagination_Pagination = (Pagination);

// EXTERNAL MODULE: ./components/cart/Pagination/index.module.scss
var Pagination_index_module = __webpack_require__(55954);
var Pagination_index_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_index_module);
;// CONCATENATED MODULE: ./components/cart/Pagination/index.jsx





const CartPagination = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Pagination_index_module_default()).CartPaginationWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_LoadMore, {
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_Pagination, {
                ...props
            })
        ]
    });
};
/* harmony default export */ var cart_Pagination = (CartPagination);


/***/ }),

/***/ 55954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CartPaginationWrapper":"Pagination_CartPaginationWrapper__24WII"};

/***/ }),

/***/ 15803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productPerPageWrapper":"ProductsPerPage_productPerPageWrapper___0U26"};

/***/ })

}]);